import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-composition-modify',
  templateUrl: './product-composition-modify.component.html',
  styleUrls: ['./product-composition-modify.component.css']
})
export class ProductCompositionModifyComponent implements OnInit {

  productCompositioncList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleproductCompositionData: any= []
  deleteProductCompositionId:any = ""


  isEditComposition:any = false
  uomData:any = [];
  productName:any = ""
  batchPrice:any = ""
  batchQuantity:any = ""
  isDefault:any = ""
  done:any = [];
  amount:any = 0
  cProductList: any= []
  uomDropdownList:any = [];
  uomSelectedList:any = [];
  uomDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  first: number = 0;
  products:any = []
  isLoading: any = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
    this.getAllCProduct()
    this.getAllUomMaster()
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.amount = 0
    for(let i=0; i<this.done.length;i++){
      console.log(this.done[i].price)
      if(this.done[i].price != 0){
        this.amount += Number(this.done[i].price) * Number(this.done[i].qty)
      }
    }

    for(let i=0; i<this.cProductList.length;i++){
      this.cProductList[i].qty = 1
    }
  }

  getAllCProduct(){
    this.generic_service.getAllcProductMaster().subscribe(
      (response:any)=>{
        console.log(response);
        this.cProductList = [];

        for(let i=0; i<response.response.length;i++){
          let body = {
            "name": String(response.response[i].name),
            "qty": 1,
            "uom": "",
            "price": Number(response.response[i].price),
          }
          this.cProductList.push(body)
        }
      }
    )
  }

  amountChanged(){
    this.amount = 0
    for(let i=0; i<this.done.length;i++){
      console.log(this.done[i].price)
      if(this.done[i].price != 0){
        this.amount += Number(this.done[i].price) * Number(this.done[i].qty)
      }
    }
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomDropdownList = res.response
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getProductCompositionById(id:any){
    this.generic_service.getProductCompositionById(id).subscribe(
      (res:any)=>{
        console.log(res)
        let totalAmount:any = 0
        for(var i=0; i<res.response.productCompositionIngList.length; i++){
          totalAmount += res.response.productCompositionIngList[i].qty * res.response.productCompositionIngList[i].price
        }
        res.response.totalAmount = totalAmount
        this.singleproductCompositionData = []
        this.singleproductCompositionData.push(res.response)
        console.log(this.singleproductCompositionData)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
  }

  getAllProductComposition(pageNumber:any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllProductComposition(pageNumber,recordsPerPage).subscribe(
      (response:any)=> {
        console.log(response)
        this.productCompositioncList = response.response.productCompositionList
        this.totalRecords = response.response.totalRecords
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }


  deleteProduct(id:any){
    this.deleteProductCompositionId = id
  }

  deleteProductComposition(){
    this.generic_service.deleteProductComposition(this.deleteProductCompositionId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  editComposition(productCompositionId:any){
    this.isEditComposition = true;

    this.generic_service.getProductCompositionById(productCompositionId).subscribe(
      (res:any)=>{
        console.log(res)
        let totalAmount:any = 0
        for(var i=0; i<res.response.productCompositionIngList.length; i++){
          totalAmount += res.response.productCompositionIngList[i].qty * res.response.productCompositionIngList[i].price
        }
        this.amount = totalAmount
        this.productName = res.response.productName
        this.batchPrice = res.response.batchPrice
        this.batchQuantity = res.response.batchQuantity
        res.response.totalAmount = totalAmount
        this.uomSelectedList = []

        for(let i = 0; i < res.response.supportedUOMObjList.length; i++) {

          this.uomSelectedList.push(
            {
              "uomMasterId": res.response.supportedUOMObjList[i].uomId,
              "uomName": res.response.supportedUOMObjList[i].uomName
            }
          )

          if(res.response.supportedUOMObjList[i].isDefault){
            this.isDefault = res.response.supportedUOMObjList[i].uomName
          }
         
        }
        this.isDefault = res.response.isDefault

        this.singleproductCompositionData = []
        this.singleproductCompositionData.push(res.response)
        console.log(this.singleproductCompositionData)
        this.done = res.response.productCompositionIngList
        if(this.singleproductCompositionData.length !== 0) {
          this.generic_service.getAllcProductMaster().subscribe(
            (response:any)=>{
              console.log(response);
              this.cProductList = response.response;
            }
          )
        }
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  editCProduct(){
    let supportedUOMObjList:any = []

    for(let j = 0; j < this.uomSelectedList.length;j++) {
      for(let i = 0; i < this.uomDropdownList.length;i++) {
        if(this.uomSelectedList[j].uomMasterId == this.uomDropdownList[i].uomMasterId){
          if(this.uomSelectedList[j].uomMasterId == this.isDefault){
            supportedUOMObjList.push(
              {
                "uomId": this.uomDropdownList[i].uomMasterId,
                "uomName": this.uomDropdownList[i].uomName,
                "cid": this.uomDropdownList[i].cid,
                "isDefault": true
              }
            )
          }else{
            supportedUOMObjList.push(
              {
                "uomId": this.uomDropdownList[i].uomMasterId,
                "uomName": this.uomDropdownList[i].uomName,
                "cid": this.uomDropdownList[i].cid,
                "isDefault": false
              }
            )
          }
        }
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "productCompositionId": Number(this.singleproductCompositionData[0].productCompositionId),
      "productName": String(this.productName),
      "batchPrice": Number(this.batchPrice),
      "batchQuantity": Number(this.batchQuantity),
      "totalAmount": Number(this.amount),
      "supportedUOMObjList": supportedUOMObjList,
      "productCompositionIngList": this.done,
      "cid": Number(this.singleproductCompositionData[0].cid)
    }

    console.log(body);

    this.generic_service.updateProdcutComposition(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProductComposition(this.pageNumber,this.recordsPerPage)
        this.amount = ""
        this.productName = ""
        this.batchPrice = ""
        this.batchQuantity = ""
        this.uomSelectedList = []
        this.toastr.success(response.message)
        this.isEditComposition = false;
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  closeEdit() {
    this.isEditComposition = false;
  }

}